import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Play } from 'lucide-react';
import { AGREEXA_APP_URL } from '../lib/links';
export function HeroSection() {
  return <div className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-147">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-148">
        <div className="absolute inset-0 bg-hero-pattern bg-cover bg-center" data-id="element-149" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-900/80 via-navy-900/60 to-navy-900/90 dark:from-navy-900/90 dark:via-navy-900/80 dark:to-navy-900" data-id="element-150" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full flex flex-col items-center text-center" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-4xl" data-id="element-152">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass border-white/20 text-white/90 text-sm font-medium mb-8" data-id="element-153">
            <span className="w-2 h-2 rounded-full bg-orange-500 animate-pulse" data-id="element-154" />
            Introducing Agreexa AI Generator
          </motion.div>

          <h1 className="text-6xl md:text-8xl font-bold text-white tracking-tight mb-6 leading-tight" data-id="element-155">
            Build{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600" data-id="element-156">
              Anything.
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-157">
            Discover thousands of step-by-step projects, AI-powered guides,
            smart home ideas, maker tutorials and DIY innovations designed for
            modern creators.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-158">
            <a href={AGREEXA_APP_URL} className="w-full sm:w-auto px-8 py-4 rounded-full bg-orange-500 hover:bg-orange-600 text-white font-semibold text-lg transition-all transform hover:scale-105 flex items-center justify-center gap-2 shadow-lg shadow-orange-500/25" data-id="element-159">
              Start Building <ArrowRight size={20} data-id="element-160" />
            </a>
            <a href={AGREEXA_APP_URL} className="w-full sm:w-auto px-8 py-4 rounded-full glass hover:bg-white/20 text-white font-semibold text-lg transition-all flex items-center justify-center gap-2" data-id="element-161">
              <Play size={20} className="fill-current" data-id="element-162" /> Explore Projects
            </a>
          </div>
        </motion.div>

        {/* Stats / Trust indicators */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-16 border-t border-white/10 pt-10 w-full max-w-4xl" data-id="element-163">
          {[{
          label: 'Active Makers',
          value: '2M+'
        }, {
          label: 'Projects',
          value: '150k+'
        }, {
          label: 'AI Guides Generated',
          value: '500k+'
        }, {
          label: 'Community Rating',
          value: '4.9/5'
        }].map((stat, i) => <div key={i} className="text-center" data-id="element-164">
              <div className="text-3xl md:text-4xl font-bold text-white mb-1" data-id="element-165">
                {stat.value}
              </div>
              <div className="text-sm text-gray-400 font-medium uppercase tracking-wider" data-id="element-166">
                {stat.label}
              </div>
            </div>)}
        </motion.div>
      </div>
    </div>;
}